import MiniProfile from "./MiniProfile";
export default MiniProfile;